import { module } from 'modujs';
import { gsap } from '../gsap'

export default class Morph extends module {

    static get settings() {
        return {
            CLASSNAME: 'o-morph',
            VISIBLE_CLASS: 'is-visible'
        }
    }

    constructor(m) {
        super(m);

        // Define vars
        this.$img = this.$('image')[0]
        this.$svg = this.$('svg')[0]
        this.$path = this.$('path')[0]
        this.$rect = this.$('rect')[0]

        // Define if scrolltrigger is needed
        this.noScrolltrigger = this.getData('no-scrolltrigger') !== null
    }

    init() {

        this.isActive = true

        // Animation
        this.tl = gsap.timeline({
            defaults: {
                ease: 'expo.out',
                duration: 2
            },
            onStart: () => {
                if(this.noScrolltrigger) {
                    this.onStart()
                }
            },
            onComplete: () => {
                if(this.noScrolltrigger) {
                    this.onEnd()
                }
            },
            scrollTrigger: this.noScrolltrigger ? null : {
                trigger: this.el,
                start: 'top 80%',
                end: 'top 20%',
                scrub: 1,
                onEnter: () => this.onStart(),
                onLeave: () => this.onEnd()
            },
        })

        this.tl
            .from(this.el, {
                yPercent: 25,
                scale: 1.2,
            }, 0)
            .to(this.$path, {
                scale: 1.05,
                morphSVG: {
                    shape: this.$rect,
                    type: 'rotational'
                },
            }, 0)
    }

    onStart() {
        this.el.classList.add(Morph.settings.VISIBLE_CLASS)
    }

    onEnd() {

        // Kill animation
        this.tl.kill()
        this.tl = false

        // Clear inline styles
        gsap.set([this.el, this.$img], {clearProps: 'all'})

        // Remove svg
        this.$svg.remove()

        // Remove css morph class
        this.el.classList.remove(Morph.settings.CLASSNAME)

        this.isActive = false
    }

    destroy() {
        if(this.tl) {
            this.tl.kill()
        }
    }
}
